<template>
  <div class="text-xs-center">
    <Board 
      :match="match"
      :reverse="reverse"
      @scoreClicked="goMatch"
      @onAddPlayer="onAddPlayer"
      @onSendEvent="onSendEvent"
      @onRemoveEvent="onRemoveEvent" />
    <v-layout 
      v-if="match.lastUpdatedBy"
      class="text-xs-center caption grey--text my-1" >
      <span v-if="match.boardDataMode">{{ match.boardDataMode.toUpperCase() }}</span>
      <v-spacer/>
      {{ $t('page.match.lastScoreUpdatedBy',{name: match.lastUpdatedBy}) }}
    </v-layout>
  </div>
</template>

<script>
import Board from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board'
// const debug = require('debug')('OD::MatchBoard')

export default {
  name: 'MatchBoard',
  components: { Board },
  props: {
    match: {
      type: Object,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onAddPlayer({ team, player }) {
      this.$emit(
        'onAddPlayer',
        Object.assign({
          config: this.match.config,
          matchId: this.match.id,
          set: this.match.setIndex,
          team,
          player,
        })
      )
    },
    onSendEvent({ data, team, player, extraPlayer, linked }) {
      this.$emit(
        'onSendEvent',
        Object.assign(
          {
            config: this.match.config,
            matchId: this.match.id,
            set: this.match.setIndex,
            team,
            player,
            extraPlayer,
            linked,
          },
          data
        )
      )
    },
    onRemoveEvent() {
      let index = this.match.setIndex
      if (
        !this.match.sets[index].events ||
        (this.match.sets[index].events && this.match.sets[index].events.length === 0)
      ) {
        if (index > 0) {
          index -= 1
        }
      }
      this.$emit('onRemoveLastEvent', {
        config: this.match.config,
        matchId: this.match.id,
        set: index,
      })
    },
    goMatch() {
      this.$emit('goMatch', this.match)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
